import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpand = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	stroke: "currentColor",
	strokeWidth: "0.4px",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M8.77 15.75a.5.5 0 0 1-.35-.15L4.79 12l3.63-3.6c.2-.19.51-.19.71 0 .19.2.19.51 0 .71l-2.91 2.9 2.91 2.9c.2.19.2.51 0 .71a.5.5 0 0 1-.35.15zM15.23 15.75a.5.5 0 0 1-.35-.15.5.5 0 0 1 0-.71l2.91-2.9-2.91-2.9a.5.5 0 0 1 0-.71.5.5 0 0 1 .71 0l3.63 3.6-3.63 3.6q-.15.15-.35.15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M18.5 12.5h-13A.5.5 0 0 1 5 12c0-.28.22-.5.5-.5h13c.28 0 .5.22.5.5a.5.5 0 0 1-.5.5M3 19a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5s.5.22.5.5v13a.5.5 0 0 1-.5.5M21 19a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5s.5.22.5.5v13a.5.5 0 0 1-.5.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M20.5 5.5c0-.28.47-.5.75-.5z"
		})
	]
});
export default SvgExpand;
